import React, { createContext, useState, useContext } from 'react';

// 1. Naya Context banayein
const LanguageContext = createContext();

// 2. Ek custom Hook banayein (taaki ise aasani se istemal kar sakein)
export const useLanguage = () => {
    return useContext(LanguageContext);
};

// 3. Provider component banayein (jo poori App ko wrap karega)
export const LanguageProvider = ({ children }) => {
    // Default bhasha 'en' (English) set karein
    const [language, setLanguage] = useState('en'); 

    // Bhasha ko EN <-> HI switch karne ke liye function
    const toggleLanguage = () => {
        setLanguage((prevLang) => (prevLang === 'en' ? 'hi' : 'en'));
    };

    const value = {
        language,       // Current language ('en' ya 'hi')
        toggleLanguage  // Function jo "HI" button call karega
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};